import React from 'react';
import omit from 'lodash/omit';
import { Icon } from '../Icon';
import constants from 'Constants';
import './styles.scss';


const BpIcon = (props) => {
  const { set, ...otherProps } = props;
  return (
    <Icon {...otherProps} set={constants.ICON_SET_BLUEPRINT} />
  );
}


BpIcon.propTypes = omit(Icon.propTypes, 'set');
BpIcon.defaultProps = omit(Icon.defaultProps, 'set');
export { BpIcon };
